const language = {
  'zh-CN': {
    dma_langName: '简体中文',
    dma_yhtk: '用户条款',
    dma_ysxy: '隐私协议',
    dma_gxhgg: '个性化广告',
    dma_kx: '（可选）',
    dma_gxhgg_subText: '*关闭此选项，即可选择不将您的资料用于个性化广告。',
    dma_allAgree: '全部同意',
    dma_agree: '同意',
    dma_qxgxxy: '请先勾选协议表示同意',
    dma_ggTitle: '个性化广告',
    dma_ggContent:
      '您可以选择是否允许我们使用您的个人信息向您提供个性化广告。如果您同意，我们将会把您的个人信息分享给我们的合作伙伴，用于向您提供可能更有趣的广告。如果您不同意，我们不会将您的个人信息用于以上目的。您可能依然会收到广告，但是这些广告将不会根据您的个人信息进行个性化，可能不再符合您的偏好。在您选择同意我们使用您的个人信息向您提供个性化广告之后，可以随时在游戏的用户中心撤回该项同意。',
    dma_save: '保存',
    dma_back: '返回',
    dma_saveSuccess: '保存成功'
  },
  'zh-TW': {
    dma_langName: '繁體中文',
    dma_yhtk: '用戶條款',
    dma_ysxy: '隱私協議',
    dma_gxhgg: '個性化廣告',
    dma_kx: '（可選）',
    dma_gxhgg_subText: '*關閉此選項，即可選擇不將您的資料用於個人化廣告。',
    dma_allAgree: '全部同意',
    dma_agree: '同意',
    dma_qxgxxy: '請先勾選協議表示同意',
    dma_ggTitle: '個性化廣告',
    dma_ggContent:
      '您可以選擇是否允許我們使用您的個人資訊向您提供個性化廣告。如果您同意，我們將會把您的個人資訊分享給我們的合作夥伴，用於向您提供可能更有趣的廣告。如果您不同意，我們不會將您的個人資訊用於以上目的。您可能依然會收到廣告，但是這些廣告將不會根據您的個人資訊進行個性化，可能不再符合您的偏好。在您選擇同意我們使用您的個人信息向您提供個性化廣告之後，可以隨時在遊戲的用戶中心撤回該項同意。',
    dma_save: '保存',
    dma_back: '返回',
    dma_saveSuccess: '保存成功'
  },
  'en-US': {
    dma_langName: 'English',
    dma_yhtk: 'User Agreement',
    dma_ysxy: 'Privacy Policy',
    dma_gxhgg: 'Personalized Ads',
    dma_kx: '(Optional)',
    dma_gxhgg_subText: '*Turn off to opt out of sharing your data for personalized ads.',
    dma_allAgree: 'Agree to all',
    dma_agree: 'Agree',
    dma_qxgxxy: 'Select item(s) to agree',
    dma_ggTitle: 'Personalized Ads',
    dma_ggContent:
      "You have the choice to allow us to utilize your personal information for the purpose of personalized advertisements. If you consent, your personal information will be shared with our partners to deliver ads that are aligned to your interest or to help you discover something new. Conversely, if you choose not to allow this, your personal information will not be used for the aforementioned purpose. You may still receive advertisements, however, they will not be personalized according to your personal information and may be less relevant. Should you initially give consent for us to use your personal information for personalized advertisements, you have the right to revoke this consent at any time by adjusting your preferences in the game's user center.",
    dma_save: 'Save',
    dma_back: 'Back',
    dma_saveSuccess: 'Saved'
  },
  'ja-JP': {
    dma_langName: '日本語',
    dma_yhtk: '利用規約',
    dma_ysxy: 'プライバシーポリシー',
    dma_gxhgg: 'パーソナライズド広告',
    dma_kx: '（オプション）',
    dma_gxhgg_subText: '*オフにすると、パーソナライズド広告のためのデータ共有をオプトアウトできます。',
    dma_allAgree: '全て同意',
    dma_agree: '同意',
    dma_qxgxxy: '上記の規約に同意してください。',
    dma_ggTitle: 'パーソナライズド広告',
    dma_ggContent:
      'パーソナライズド広告の利用に同意した場合、お客様の個人情報は当社の提携会社に共有されます。共有された情報によって、お客様の好みを推測して、より興味深い広告を提供いたします。同意後、いつでもユーザーセンターで同意を取り消すことができます。\n' +
      'パーソナライズド広告の利用に同意しない場合、カスタマイズされた広告は受信されず、上記の目的でお客様の個人情報を利用することはありませんので、ご安心ください。',
    dma_save: '保存',
    dma_back: '戻る',
    dma_saveSuccess: '保存成功'
  },
  'ko-KR': {
    dma_langName: '한국어',
    dma_yhtk: '사용자 약관',
    dma_ysxy: '개인정보 처리방침',
    dma_gxhgg: '마케팅 활용 동의',
    dma_kx: '(선택)',
    dma_gxhgg_subText: '*비활성화하면 개인 맞춤형 광고를 위한 데이터 공유에 동의하지 않게 됩니다.',
    dma_allAgree: '전체 동의',
    dma_agree: '동의',
    dma_qxgxxy: '선택 후 동의를 눌러주세요',
    dma_ggTitle: '광고성 정보',
    dma_ggContent:
      '고객님의 개인 정보를 이용하여 광고성 정보를 제공할 수 있는지 여부를 선택하실 수 있습니다. 동의하신다면 저희 협력사에게 공유하게 되어 더 흥미로운 광고를 제공하겠습니다. 동의하지 않으시면 개인정보는 위와 같은 목적으로 이용하지 않습니다. 여전히 광고를 받으실 수 있지만, 해당 광고는 개인 정보에 따라 커스텀되지 않고 더 이상 선호도에 맞지 않을 수 있습니다. 귀하의 개인 정보를 사용하여 광고성 정보를 제공하는 것에 동의하신 후 언제든지 게임 사용자 센터에서 동의를 철회할 수 있습니다.',
    dma_save: '저장',
    dma_back: '돌아가기',
    dma_saveSuccess: '저장 성공'
  },
  'th-TH': {
    dma_langName: 'ภาษาไทย',
    dma_yhtk: 'ข้อตกลงผู้ใช้งาน',
    dma_ysxy: 'นโยบายความเป็นส่วนตัว',
    dma_gxhgg: 'โฆษณาที่ปรับตามความสนใจ',
    dma_kx: '(ไม่บังคับ)',
    dma_gxhgg_subText: '*ปิดเพื่อปฏิเสธการแชร์ข้อมูลของคุณสำหรับโฆษณาที่ปรับตามความสนใจ',
    dma_allAgree: 'ยินยอมทั้งหมด',
    dma_agree: 'ยินยอม',
    dma_qxgxxy: 'โปรดทำเครื่องหมายถูกเพื่อแสดงความยินยอม',
    dma_ggTitle: 'โฆษณาเฉพาะบุคคล',
    dma_ggContent:
      'ท่านสามารถเลือกได้ว่าจะอนุญาตให้เราใช้ข้อมูลส่วนตัวของท่านเพื่อแนะนำโฆษณาเฉพาะบุคคลให้ท่านหรือไม่ หากท่านยินยอม เราจะแชร์ข้อมูลส่วนตัวของท่านให้พันธมิตรทางธุรกิจของเรา เพื่อแนะนำโฆษณาที่น่าสนใจกว่าให้ท่าน หากท่านไม่ยินยอม เราจะไม่นำข้อมูลของท่านไปใช้ในจุดประสงค์ข้างต้น ท่านอาจจะยังคงได้รับโฆษณา แต่โฆษณาเหล่านี้จะไม่ใช่โฆษณาที่สอดคล้องกับข้อมูลและความชอบของท่าน หลังท่านยินยอมให้เราใช้ข้อมูลส่วนตัวของท่านแนะนำโฆษณาเฉพาะบุคคล สามารถยกเลิกการยินยอมนี้ในศูนย์ผู้ใช้งานภายในเกมได้ทุกเมื่อ',
    dma_save: 'บันทึก',
    dma_back: 'กลับ',
    dma_saveSuccess: 'บันทึกสำเร็จ'
  },
  'vi-VN': {
    dma_langName: 'Tiếng Trung Phồn Thể',
    dma_yhtk: 'Điều Khoản Người Dùng',
    dma_ysxy: 'Thỏa Thuận Bảo Mật',
    dma_gxhgg: 'Quảng cáo được cá nhân hóa',
    dma_kx: '(Tùy chọn)',
    dma_gxhgg_subText: '*Tắt để từ chối chia sẻ dữ liệu của bạn cho quảng cáo được cá nhân hóa.',
    dma_allAgree: 'Đồng ý hết',
    dma_agree: 'Đồng ý',
    dma_qxgxxy: 'Vui lòng chọn đồng ý thỏa thuận',
    dma_ggTitle: 'Quảng cáo tùy chỉnh',
    dma_ggContent:
      'Bạn có thể chọn có cho phép chúng tôi sử dụng thông tin cá nhân của bạn để cung cấp quảng cáo tùy chỉnh cho bạn hay không. Nếu bạn đồng ý, chúng tôi sẽ chia sẻ thông tin cá nhân của bạn với đối tác của chúng tôi để cung cấp quảng cáo thú vị hơn cho bạn. Nếu bạn không đồng ý, chúng tôi sẽ không sử dụng thông tin cá nhân của bạn cho mục đích trên. Bạn vẫn có thể nhận được quảng cáo, nhưng quảng cáo đó sẽ không tùy chỉnh dựa trên thông tin cá nhân của bạn và có thể không phù hợp với sở thích của bạn. Sau khi bạn chọn đồng ý cho chúng tôi sử dụng thông tin cá nhân của bạn để cung cấp quảng cáo tùy chỉnh, bạn có thể rút lại sự đồng ý đó bất cứ lúc nào tại trung tâm người dùng của trò chơi.',
    dma_save: 'Lưu',
    dma_back: 'Quay lại',
    dma_saveSuccess: 'Lưu thành công'
  },
  'de-DE': {
    dma_langName: 'Deutsch',
    dma_yhtk: 'Nutzungsvereinbarung',
    dma_ysxy: 'Datenschutzrichtlinie',
    dma_gxhgg: 'Personalisierte Werbung',
    dma_kx: '(optional)',
    dma_gxhgg_subText: '*Deaktivieren Sie diese Option, um der Nutzung Ihrer Daten für personalisierte Werbung zu widersprechen.',
    dma_allAgree: 'Allen zustimmen',
    dma_agree: 'Zustimmen',
    dma_qxgxxy: 'Zuzustimmende(n) Punkt(e) auswählen',
    dma_ggTitle: 'Personalisierte Werbung',
    dma_ggContent:
      'Du hast die Wahl, ob du uns erlaubst, deine persönlichen Daten für personalisierte Werbung zu verwenden. Wenn du zustimmst, werden deine persönlichen Daten an unsere Partner weitergegeben, um dir Werbung zu bieten, die auf deine Interessen abgestimmt ist, oder um dir zu helfen, etwas Neues zu entdecken. Andererseits werden deine persönlichen Daten nicht für den oben genannten Zweck verwendet, wenn du dem nicht zustimmst. Du erhältst dann zwar weiterhin Werbung, diese ist jedoch nicht auf deine persönlichen Daten zugeschnitten und möglicherweise weniger relevant für dich. Solltest du uns deine Zustimmung zur Verwendung deiner persönlichen Daten für personalisierte Werbung geben, hast du das Recht, diese Zustimmung jederzeit zu widerrufen, indem du deine Einstellungen im Benutzerzentrum des Spiels anpasst.',
    dma_save: 'Speichern',
    dma_back: 'Zurück',
    dma_saveSuccess: 'Gespeichert'
  },
  'fr-FR': {
    dma_langName: 'Français',
    dma_yhtk: "Conditions d'Utilisation",
    dma_ysxy: 'Politique de Confidentialité',
    dma_gxhgg: 'Publicités personnalisées',
    dma_kx: '(facultatif)',
    dma_gxhgg_subText: '*Désactivez cette option pour refuser le partage de vos données à des fins de publicité personnalisée.',
    dma_allAgree: 'Accepter tout',
    dma_agree: "D'accord",
    dma_qxgxxy: 'Sélectionner le(s) objet(s) à accepter',
    dma_ggTitle: 'Publicités Personnalisées',
    dma_ggContent:
      "Vous avez la possibilité de nous autoriser à utiliser vos informations personnelles à des fins de publicité personnalisée. Si vous y consentez, vos informations personnelles seront partagées avec nos partenaires afin de vous proposer des publicités qui correspondent à vos intérêts ou de vous aider à découvrir quelque chose de nouveau. Inversement, si vous choisissez de ne pas l'autoriser, vos informations personnelles ne seront pas utilisées aux fins susmentionnées. Vous pourrez toujours recevoir des publicités, mais elles ne seront pas personnalisées en fonction de vos informations personnelles et pourront être moins pertinentes. Si vous consentez initialement à ce que nous utilisions vos informations personnelles pour des publicités personnalisées, vous avez le droit de révoquer ce consentement à tout moment en ajustant vos préférences dans le centre d'utilisateurs du jeu.",
    dma_save: 'Sauvegarder',
    dma_back: 'Retour',
    dma_saveSuccess: 'Enregistré'
  },
  'ru-RU': {
    dma_langName: 'Русский',
    dma_yhtk: 'Пользоват. соглашение',
    dma_ysxy: 'Политика конфиденц.',
    dma_gxhgg: 'Персонализированная реклама',
    dma_kx: ' (необязательно)',
    dma_gxhgg_subText: '*Отключите, чтобы отказаться от передачи ваших данных для персонализированной рекламы.',
    dma_allAgree: 'Принять всё',
    dma_agree: 'Согласен',
    dma_qxgxxy: 'Выберите пункты для согласия',
    dma_ggTitle: 'Персонализ. реклама',
    dma_ggContent:
      'Вы можете разрешить нам использовать вашу личную информацию в целях показа персонализированной рекламы. В случае согласия ваша личная информация будет передана нашим партнёрам, чтобы вы получали рекламу, наиболее подходящую вашими интересам, или рекламу, которая поможет вам узнать что-нибудь новое. В противном случае ваша личная информация не будет использоваться для указанных вышей целей. Вы по-прежнему сможете просматривать рекламу, однако она не будет персонализирована в соответствии с вашей личной информацией и может оказаться менее релевантной. Если вы дадите согласие на использование вашей личной информации для персонализированной рекламы, вы имеете право отозвать это согласие в любое время, изменив свои настройки в центре пользователя.',
    dma_save: 'Сохранить',
    dma_back: 'Назад',
    dma_saveSuccess: 'Сохранено'
  },
  'es-ES': {
    dma_langName: 'Español',
    dma_yhtk: 'Acuerdo de usuario',
    dma_ysxy: 'Política de privacidad',
    dma_gxhgg: 'Anuncios personalizados',
    dma_kx: '(opcional)',
    dma_gxhgg_subText: '*Desactiva esta opción para rechazar el uso de tus datos en anuncios personalizados.',
    dma_allAgree: 'Aceptar todo',
    dma_agree: 'Aceptar',
    dma_qxgxxy: 'Seleccione los campos que acepta',
    dma_ggTitle: 'Anuncios personalizados',
    dma_ggContent:
      'Tienes la opción de permitirnos usar tu información personal para enviar anuncios personalizados. Si estás de acuerdo, nuestros socios tendrán acceso a tu información personal con el fin de ofrecerte anuncios que se ajusten a tus intereses o ayudarte a descubrir algo nuevo. Sin embargo, si decides no compartir esta información, tus datos no se utilizarán para tal fin. Seguirás recibiendo anuncios, pero no serán personalizados según tu información personal y podrían ser menos relevantes para ti. Si ya aceptaste compartir tu información personal para recibir anuncios personalizados, tendrás el derecho a revocar este consentimiento en cualquier momento modificando las preferencias en el centro de usuario del juego.',
    dma_save: 'Guardar',
    dma_back: 'Volver',
    dma_saveSuccess: 'Guardado'
  },
  'pt-PT': {
    dma_langName: 'Português',
    dma_yhtk: 'Termo de Acordo do Usuário',
    dma_ysxy: 'Política de Privacidade',
    dma_gxhgg: 'Anúncios personalizados',
    dma_kx: '(opcional)',
    dma_gxhgg_subText: '*Desative para recusar o compartilhamento dos seus dados para anúncios personalizados.',
    dma_allAgree: 'Concordar com todos',
    dma_agree: 'Concordar',
    dma_qxgxxy: 'Selecione os itens para concordar',
    dma_ggTitle: 'Anúncios personalizados',
    dma_ggContent:
      'Você tem a opção de nos permitir utilizar suas informações pessoais para fins de anúncios personalizados. Se você consentir, suas informações pessoais serão compartilhadas com nossos parceiros para veicular anúncios alinhados aos seus interesses ou para ajudá-lo a descobrir algo novo. Por outro lado, se você optar por não permitir isso, suas informações pessoais não serão utilizadas para os fins acima mencionados. Você ainda poderá receber anúncios, porém, eles não serão personalizados de acordo com suas informações pessoais e poderão ser menos relevantes. Se você inicialmente nos der consentimento para usarmos suas informações pessoais para anúncios personalizados, você terá o direito de revogar esse consentimento a qualquer momento, ajustando suas preferências na central do usuário do jogo.',
    dma_save: 'Salvar',
    dma_back: 'Voltar',
    dma_saveSuccess: 'Salvo'
  },
  'it-IT': {
    dma_langName: 'Italiano',
    dma_yhtk: 'Accordo Utente',
    dma_ysxy: 'Politica sulla Privacy',
    dma_gxhgg: 'Annunci personalizzati',
    dma_kx: '(facoltativo)',
    dma_gxhgg_subText: '*Disattiva per rifiutare la condivisione dei tuoi dati per annunci personalizzati.',
    dma_allAgree: 'Accetta Tutto',
    dma_agree: 'Accetta',
    dma_qxgxxy: 'Seleziona voce(i) da accettare',
    dma_ggTitle: 'Pubblicità Personalizzate',
    dma_ggContent:
      "Hai la possibilità di consentire l'utilizzo delle tue informazioni personali per scopi di pubblicità personalizzate. Se acconsenti, le tue informazioni personali verranno condivise con i nostri partner per fornire annunci pubblicitari in linea con i tuoi interessi o per aiutarti a scoprire qualcosa di nuovo. Al contrario, se scegli di non permettere ciò, le tue informazioni personali non verranno utilizzate per i suddetti scopi. Potresti comunque ricevere annunci pubblicitari, tuttavia, questi non saranno personalizzati in base alle tue informazioni personali e potrebbero essere meno pertinenti. Nel caso in cui tu dia inizialmente il consenso all'uso delle tue informazioni personali per le pubblicità personalizzate, hai il diritto di revocare tale consenso in qualsiasi momento, modificando le tue preferenze nel centro utenti del gioco.",
    dma_save: 'Salva',
    dma_back: 'Indietro',
    dma_saveSuccess: 'Salvato'
  },
  'tr-TR': {
    dma_langName: 'Türkçe',
    dma_yhtk: 'Kullanıcı Sözleşmesi',
    dma_ysxy: 'Gizlilik Politikası',
    dma_gxhgg: 'Kişiselleştirilmiş Reklamlar',
    dma_kx: '(İsteğe bağlı)',
    dma_gxhgg_subText: '*Kişiselleştirilmiş reklamlar için verilerinizin paylaşılmasını reddetmek için kapatın.',
    dma_allAgree: 'Tümünü Kabul Et',
    dma_agree: 'Kabul Et',
    dma_qxgxxy: 'Kabul edilecek öğe(ler)i seç',
    dma_ggTitle: 'Kişiselleştirilmiş Reklamlar',
    dma_ggContent:
      'Sizin kişisel bilgilerinizi, kişiselleştirilmiş reklam amacıyla kullanmamıza izin verme seçeneğiniz bulunmaktadır. Eğer onaylarsanız, kişisel bilgileriniz ilgi alanlarınıza uygun reklamlar sunmak veya yeni şeyler keşfetmenize yardımcı olmak amacıyla iş ortaklarımızla paylaşılacaktır. Buna izin vermediğiniz takdirde, kişisel bilgileriniz yukarıda belirtilen amaçlar için kullanılmayacaktır. Yine de reklam almaya devam edebilirsiniz, ancak bunlar kişisel bilgilerinize göre kişiselleştirilmeyecek ve daha az alakalı olabilir. Başlangıçta kişisel bilgilerinizi kişiselleştirilmiş reklamlar için kullanmamıza izin vermeniz durumunda, oyunun kullanıcı merkezindeki tercihlerinizi ayarlayarak bu izni istediğiniz zaman iptal etme hakkına sahipsiniz.',
    dma_save: 'Kaydet',
    dma_back: 'Geri',
    dma_saveSuccess: 'Kaydedildi'
  },
  'pl-PL': {
    dma_langName: 'Polski',
    dma_yhtk: 'Umowa użytkownika',
    dma_ysxy: 'Polityka prywatności',
    dma_gxhgg: 'Spersonalizowane reklamy',
    dma_kx: '(opcjonalne)',
    dma_gxhgg_subText: '*Wyłącz, aby zrezygnować z udostępniania Twoich danych na potrzeby spersonalizowanych reklam.',
    dma_allAgree: 'Zgoda na wszystko',
    dma_agree: 'Zgoda',
    dma_qxgxxy: 'Wybierz elementy do zgody',
    dma_ggTitle: 'Spersonalizowane reklamy',
    dma_ggContent:
      'Użytkownik ma możliwość wyrażenia zgody na wykorzystywanie przez nas jego danych osobowych w celu wyświetlania spersonalizowanych reklam. Jeśli użytkownik zgodzi się na to, jego dane osobowe będą udostępniane naszym partnerom w celu dostarczania reklam dostosowanych do jego zainteresowań lub pomagających mu odkryć coś nowego. Jeśli zaś użytkownik nie wyrazi na to zgody, jego dane osobowe nie będą wykorzystywane do wyżej wymienionych celów. Użytkownik może w dalszym ciągu otrzymywać reklamy, jednak nie będą one spersonalizowane zgodnie z jego danymi osobowymi i mogą być mniej trafne. W przypadku początkowego wyrażenia zgody na wykorzystywanie przez nas danych osobowych użytkownika w celu wyświetlania spersonalizowanych reklam, użytkownik ma prawo do cofnięcia tej zgody w dowolnym momencie poprzez dostosowanie swoich preferencji w centrum użytkownika gry.',
    dma_save: 'Zapisz',
    dma_back: 'Wróć',
    dma_saveSuccess: 'Zapisano'
  },
  'id-ID': {
    dma_langName: 'Bahasa Indonesia',
    dma_yhtk: 'Persyaratan Pengguna',
    dma_ysxy: 'Perjanjian Privasi',
    dma_gxhgg: 'Iklan yang Dipersonalisasi',
    dma_kx: '(Opsional)',
    dma_gxhgg_subText: '*Nonaktifkan untuk menyetujui agar data Anda tidak digunakan untuk iklan yang dipersonalisasi.',
    dma_allAgree: 'Setuju Semua',
    dma_agree: 'Setuju',
    dma_qxgxxy: 'Silakan centang perjanjian untuk menyetujui',
    dma_ggTitle: 'Iklan Personalisasi',
    dma_ggContent:
      'Anda bisa memilih apakah mengizinkan kami menggunakan informasi pribadi Anda untuk menyediakan iklan yang personalisasi ke Anda. Jika Anda setuju, kami akan membagikan informasi pribadi Anda ke mitra kami, digunakan untuk menyediakan iklan yang lebih menarik untuk Anda. Jika Anda tidak setuju, kami tidak akan menggunakan informasi pribadi Anda untuk tujuan di atas. Anda mungkin masih akan menerima iklan, tapi iklan ini tidak akan dipersonalisasi berdasarkan informasi pribadi Anda dan mungkin tidak lagi sesuai dengan favorit Anda. Setelah Anda mengizinkan kami menggunakan informasi pribadi Anda untuk menyediakan iklan personalisasi ke Anda, Anda bisa membatalkan persetujuan tersebut kapan saja di pusat pengguna game.',
    dma_save: 'Simpan',
    dma_back: 'Kembali',
    dma_saveSuccess: 'Tersimpan'
  },
  'ar-SA': {
    dma_langName: 'العربية الفصحى',
    dma_yhtk: 'اتفاقية المستخدم',
    dma_ysxy: 'سياسة الخصوصية',
    dma_gxhgg: 'الإعلانات المخصصة',
    dma_kx: '(اختياري)',
    dma_gxhgg_subText: 'قم بإيقاف التشغيل لإلغاء مشاركة بياناتك للإعلانات المخصصة.',
    dma_allAgree: 'موافقة على الكل',
    dma_agree: 'موافقة',
    dma_qxgxxy: 'حدد العنصر (العناصر) للموافقة عليها',
    dma_ggTitle: 'إعلانات مخصصة',
    dma_ggContent:
      'لديك خيار السماح لنا باستخدام معلوماتك الشخصية لغرض الإعلانات المخصصة. إذا وافقت، فستتم مشاركة معلوماتك الشخصية مع شركائنا لتقديم إعلانات تتوافق مع اهتماماتك أو لمساعدتك في اكتشاف شيء جديد. وعلى العكس من ذلك، إذا اخترت عدم السماح بذلك، فلن يتم استخدام معلوماتك الشخصية للغرض المذكور أعلاه. قد تستمر في تلقي الإعلانات، ومع ذلك، لن يتم تخصيصها وفقًا لمعلوماتك الشخصية وقد تكون أقل أهمية. إذا وافقت في البداية على استخدام معلوماتك الشخصية للإعلانات المخصصة، فلديك الحق في إلغاء هذه الموافقة في أي وقت عن طريق تعديل تفضيلاتك في مركز مستخدم اللعبة.',
    dma_save: 'حفظ',
    dma_back: 'عودة',
    dma_saveSuccess: 'تم الحفظ'
  },
  nl: {
    dma_langName: 'Nederlands',
    dma_yhtk: 'Gebruikersovereenkomst',
    dma_ysxy: 'Privacybeleid',
    dma_gxhgg: 'Gepersonaliseerde Advertenties',
    dma_kx: '(Optioneel)',
    dma_gxhgg_subText: '*Schakel uit om te voorkomen dat uw gegevens worden gedeeld voor gepersonaliseerde advertenties.',
    dma_allAgree: 'Akkoord met alles',
    dma_agree: 'Akkoord',
    dma_qxgxxy: 'Selecteer item(s) om mee akkoord te gaan',
    dma_ggTitle: 'Gepersonaliseerde Advertenties',
    dma_ggContent:
      'U heeft de keuze om ons toe te staan uw persoonlijke informatie te gebruiken voor het doel van gepersonaliseerde advertenties. Indien u hiermee instemt, wordt uw persoonlijke informatie gedeeld met onze partners om advertenties te tonen die aansluiten bij uw interesses of om u iets nieuws te laten ontdekken. Als u er daarentegen voor kiest dit niet toe te staan, wordt uw persoonlijke informatie niet gebruikt voor het genoemde doel. U ontvangt mogelijk nog steeds advertenties, maar deze zullen niet worden gepersonaliseerd op basis van uw persoonlijke informatie en zijn mogelijk minder relevant. Indien u in eerste instantie toestemming geeft voor het gebruik van uw persoonlijke informatie voor gepersonaliseerde advertenties, heeft u het recht deze toestemming op elk moment in te trekken door uw voorkeuren aan te passen in het gebruikerscentrum van het spel.',
    dma_save: 'Opslaan',
    dma_back: 'Terug',
    dma_saveSuccess: 'Opgeslagen'
  },
  ms: {
    dma_langName: 'Bahasa Melayu',
    dma_yhtk: 'Perjanjian Pengguna',
    dma_ysxy: 'Dasar Privasi',
    dma_gxhgg: 'Iklan Diperibadikan',
    dma_kx: '(Opsyenal)',
    dma_gxhgg_subText: '*Matikan untuk tidak bersetuju perkongsian data anda bagi iklan yang diperibadikan.',
    dma_allAgree: 'Setuju dengan semua',
    dma_agree: 'Setuju',
    dma_qxgxxy: 'Pilih item untuk bersetuju',
    dma_ggTitle: 'Iklan Diperibadikan',
    dma_ggContent:
      'Anda mempunyai pilihan untuk membenarkan kami menggunakan maklumat peribadi anda untuk tujuan pengiklanan diperibadikan. Jika anda bersetuju, maklumat peribadi anda akan dikongsi dengan rakan kongsi kami untuk menyampaikan iklan yang selari dengan inat anda atau membantu anda menemui sesuatu yang baharu. Sebaliknya, jika anda memilih untuk tidak membenarkan ini, maklumat peribadi anda tidak akan digunakan untuk tujuan yang disebutkan di atas. Anda masih akan menerima iklan, tetapi ia tidak akan diperibadikan mengikut maklumat peribadi anda dan mungkin kurang relevan. Jika anda pada asalnya memberikan kebenaran kepada kami untuk menggunakan maklumat peribadi anda untuk pengiklanan diperibadikan, anda berhak untuk menarik balik persetujuan ini pada bila-bila masa dengan melaraskan pilihan anda di pusat pengguna permainan.',
    dma_save: 'Simpan',
    dma_back: 'Kembali',
    dma_saveSuccess: 'Disimpan'
  },
  BG: {
    dma_langName: 'Български',
    dma_yhtk: 'Потребителско споразумение',
    dma_ysxy: 'Политика за поверителност',
    dma_gxhgg: 'Персонализирани реклами',
    dma_kx: '(по избор)',
    dma_gxhgg_subText:
      '*Изключете тази опция, за да не използваме данните ви за персонализирани реклами.',
    dma_allAgree: 'Съгласие с всички',
    dma_agree: 'Съгласен',
    dma_qxgxxy: 'с които да се съгласите',
    dma_ggTitle: 'Персонализирани реклами',
    dma_ggContent:
      'Имате възможност да ни разрешите да използваме вашата лична информация за персонализирани реклами. Ако се съгласите, вашата лична информация ще бъде споделена с нашите партньори, за да показват реклами, съобразени с вашите интереси или да ви помогнат да откриете нещо ново. Ако не ни разрешите, вашата лична информация няма да бъде използвана за тази цел. Все пак ще виждате реклами, но те няма да бъдат персонализирани според вашата лична информация и може да са по-малко подходящи. Ако първоначално се съгласите да използваме вашата лична информация за персонализирани реклами, имате право да отмените това съгласие по всяко време, като промените настройките си в центъра за потребители на играта.',
    dma_save: 'Запази',
    dma_back: 'Назад',
    dma_saveSuccess: 'Запазено'
  },
  CS: {
    dma_langName: 'čeština',
    dma_yhtk: 'Uživatelská smlouva',
    dma_ysxy: 'Zásady ochrany osobních údajů',
    dma_gxhgg: 'Personalizované reklamy',
    dma_kx: '(nepovinné)',
    dma_gxhgg_subText:
      '*Vypnutím této možnosti se rozhodnete neposkytovat svá data pro personalizovanou reklamu.',
    dma_allAgree: 'Souhlasím se vším',
    dma_agree: 'Souhlasím',
    dma_qxgxxy: 'Vyberte položky, se kterými souhlasíte',
    dma_ggTitle: 'Personalizované reklamy',
    dma_ggContent:
      'Máte možnost nám povolit použití vašich osobních údajů pro personalizované reklamy. Pokud souhlasíte, budou vaše osobní údaje sdíleny s našimi partnery, aby mohli zobrazovat reklamy, které odpovídají vašim zájmům nebo vám pomohou objevit něco nového. Pokud to nepovolíte, nebudou vaše osobní údaje pro tento účel použity. I přesto však můžete i nadále vidět reklamy, ale nebudou personalizované podle vašich osobních údajů a mohou být méně relevantní. Pokud nám zpočátku povolíte používat vaše osobní údaje pro personalizované reklamy, máte právo tento souhlas kdykoli odvolat úpravou svých preferencí v uživatelském centru hry.',
    dma_save: 'Uložit',
    dma_back: 'Zpět',
    dma_saveSuccess: 'Uloženo'
  },
  DA: {
    dma_langName: 'dansk',
    dma_yhtk: 'Brugeraftale',
    dma_ysxy: 'Privatlivspolitik',
    dma_gxhgg: 'Personlige annoncer',
    dma_kx: '(Valgfrit)',
    dma_gxhgg_subText:
      '*Deaktiver denne indstilling for at fravælge, at dine data bruges til personaliserede annoncer.',
    dma_allAgree: 'Acceptér alle',
    dma_agree: 'Acceptér',
    dma_qxgxxy: 'Vælg element(er) at acceptere',
    dma_ggTitle: 'Personlige annoncer',
    dma_ggContent:
      'Du har mulighed for at lade os bruge dine personlige oplysninger til personaliserede annoncer. Hvis du giver samtykke, vil dine personlige oplysninger blive delt med vores samarbejdspartnere for at vise dig annoncer, der er relevante for dine interesser eller for at hjælpe dig med at opdage noget nyt. Hvis du vælger ikke at give samtykke, vil dine personlige oplysninger ikke blive brugt til dette formål. Du vil dog stadig kunne se annoncer, men de vil ikke være personificerede ud fra dine personlige oplysninger og kan derfor være mindre relevante. Hvis du giver samtykke til brugen af dine personlige oplysninger til personaliserede annoncer, har du ret til at trække dette samtykke tilbage til enhver tid ved at justere dine indstillinger i spillets brugercenter.',
    dma_save: 'Gem',
    dma_back: 'Tilbage',
    dma_saveSuccess: 'Gemt'
  },
  ET: {
    dma_langName: 'eesti',
    dma_yhtk: 'Kasutajalepping',
    dma_ysxy: 'Privaatsustingimused',
    dma_gxhgg: 'Personaalsed reklaamid',
    dma_kx: '(Valikuline)',
    dma_gxhgg_subText:
      '*Selle suvandi keelamisel saate otsustada, et teie andmeid ei kasutata isikupärastatud reklaamides.',
    dma_allAgree: 'Nõustu kõigiga',
    dma_agree: 'Nõustu',
    dma_qxgxxy: 'Vali nõustutavad punktid',
    dma_ggTitle: 'Personaalsed reklaamid',
    dma_ggContent:
      'Teil on valik lubada meil kasutada Teie isikuandmeid personaalsete reklaamide näitamiseks. Kui Teie nõustute, jagatakse Teie isikuandmeid meie partneritega, et näidata Teile huvidele vastavaid reklaame või aidata Teid avastama midagi uut. Kui Teie seda ei luba, ei kasutata Teie isikuandmeid selleks otstarbeks. Kuid võite siiski näha reklaame, kuid need ei ole Teie isikuandmete põhjal personaalseks muudetud ja võivad olla vähem asjakohased. Kui annate algselt nõusoleku oma isikuandmete kasutamiseks personaalsete reklaamide jaoks, on Teil õigus see nõusolek igal ajal tühistada, kohandades oma eelistusi mängu kasutajakontol.',
    dma_save: 'Salvesta',
    dma_back: 'Tagasi',
    dma_saveSuccess: 'Salvestatud'
  },
  EL: {
    dma_langName: 'ελληνικά',
    dma_yhtk: 'Συμφωνία Χρήστη',
    dma_ysxy: 'Πολιτική Απορρήτου',
    dma_gxhgg: 'Εξατομικευμένες Διαφημίσεις',
    dma_kx: '(Προαιρετικό)',
    dma_gxhgg_subText:
      '*Απενεργοποιήστε αυτήν την επιλογή για να μην χρησιμοποιηθούν τα δεδομένα σας για εξατομικευμένες διαφημίσεις.',
    dma_allAgree: 'Συμφωνώ με όλα',
    dma_agree: 'Συμφωνώ',
    dma_qxgxxy: 'Επιλέξτε στοιχεία για να συμφωνήσετε',
    dma_ggTitle: 'Εξατομικευμένες Διαφημίσεις',
    dma_ggContent:
      'Έχετε την επιλογή να μας επιτρέψετε να χρησιμοποιούμε τα προσωπικά σας δεδομένα για εξατομικευμένες διαφημίσεις. Εάν συναινέσετε, τα προσωπικά σας δεδομένα θα κοινοποιηθούν στους συνεργάτες μας για να εμφανίζουν διαφημίσεις που ευθυγραμμίζονται με τα ενδιαφέροντά σας ή για να σας βοηθήσουν να ανακαλύψετε κάτι νέο. Αντιθέτως, εάν επιλέξετε να μην το επιτρέψετε, τα προσωπικά σας δεδομένα δεν θα χρησιμοποιηθούν για τον προαναφερθέντα σκοπό. Ενδέχεται να εξακολουθείτε να βλέπετε διαφημίσεις, ωστόσο δεν θα είναι εξατομικευμένες σύμφωνα με τα προσωπικά σας δεδομένα και μπορεί να είναι λιγότερο σχετικές. Εάν αρχικά δώσετε τη συγκατάθεσή σας να χρησιμοποιήσουμε τα προσωπικά σας δεδομένα για εξατομικευμένες διαφημίσεις, έχετε το δικαίωμα να την ανακαλέσετε ανά πάσα στιγμή, προσαρμόζοντας τις προτιμήσεις σας στο κέντρο χρήστη του παιχνιδιού.',
    dma_save: 'Αποθήκευση',
    dma_back: 'Πίσω',
    dma_saveSuccess: 'Αποθηκεύτηκε'
  },
  GA: {
    dma_langName: 'Gaeilge',
    dma_yhtk: 'Comhaontú Úsáideora',
    dma_ysxy: 'Polasaí Príobháideachta',
    dma_gxhgg: 'Fógraí Pearsanta',
    dma_kx: '(Roghnach)',
    dma_gxhgg_subText:
      '*Díchumasaigh an rogha seo chun rogha a dhéanamh gan do shonraí a úsáid le haghaidh fógraí pearsantaithe.',
    dma_allAgree: 'Glac le gach rud',
    dma_agree: 'Glac le',
    dma_qxgxxy: 'Roghnaigh mír(í) le glacadh leis',
    dma_ggTitle: 'Fógraí Pearsanta',
    dma_ggContent:
      "Tá sé in do chumhacht ligean dúinn do fhaisnéis pearsanta a úsáid chun fógraí a dhéanamh atá uathúil duit. Mura dtugann tú cead, ní mór dúinn do fhaisnéis pearsanta a roinnt leis na comhoiriúnaithe seo chun fógraí a thabhairt duit a bhfuil suim acu iad, nó chun cabhrú leat rud éigin nua a aimsiú. Má dhéanann tú é a dhéanamh, ní úsáidfear do fhaisnéis pearsanta don ghníomh sin. Is féidir leat fógraí fós a fháil, áfach, ach ní bheidh siad uathúla de réir do fhaisnéis pearsanta agus d'fhéadfadh go mbeadh siad níos lú cuí. Má thugann tú cead dúinn do fhaisnéis pearsanta a úsáid i gcás fógraí uathúla, tá sé i do chumhacht an cead sin a bhaint siar ag aon am trí do chéimeanna roghanna a athrú i gcroílár úsáideora na gcluichí.",
    dma_save: 'Sábháil',
    dma_back: 'Ar ais',
    dma_saveSuccess: 'Sábháilte'
  },
  HR: {
    dma_langName: 'hrvatski',
    dma_yhtk: 'Korisnički Ugovor',
    dma_ysxy: 'Pravila privatnosti',
    dma_gxhgg: 'Personalizirani oglasi',
    dma_kx: '(Opcionalno)',
    dma_gxhgg_subText:
      '*Onemogućite ovu opciju kako biste odabrali da se vaši podaci ne koriste za personalizirane oglase.',
    dma_allAgree: 'Slažem se sa svime',
    dma_agree: 'Slažem se',
    dma_qxgxxy: 'Odaberite stavke za suglasnost',
    dma_ggTitle: 'Personalizirani oglasi',
    dma_ggContent:
      'Imate mogućnost dopustiti nam upotrebu vaših osobnih informacija u svrhu personalizirane reklame. Ako pristanete, vaše osobne informacije bit će podijeljene s našim partnerima kako bi se isporučile reklame koje odgovaraju vašem interesu ili kako bismo vam pomogli otkriti nešto novo. S druge strane, ako odlučite to ne dopustiti, vaše osobne informacije neće se koristiti u svrhu navedenu ranije. Možda ćete i dalje primati reklame, ali neće biti prilagođene prema vašim osobnim informacijama i možda će biti manje relevantne. Ako prvo pristanete dopustiti nam upotrebu vaših osobnih informacija u svrhu personalizirane reklame, imate pravo povući to dopuštenje u bilo kojem trenutku prilagođavanjem svojih postavki u korisničkom centru igre.',
    dma_save: 'Spremi',
    dma_back: 'Natrag',
    dma_saveSuccess: 'Spremljeno'
  },
  LV: {
    dma_langName: 'latviešu',
    dma_yhtk: 'Lietotāja līgums',
    dma_ysxy: 'Privātuma politika',
    dma_gxhgg: 'Pielāgotas reklāmas',
    dma_kx: '(Izvēles iespēja)',
    dma_gxhgg_subText:
      '*Izslēdziet šo opciju, lai izvēlētos neizmantot jūsu datus personalizētai reklāmai.',
    dma_allAgree: 'Piekrītu visam',
    dma_agree: 'Piekrītu',
    dma_qxgxxy: 'Izvēlieties vienumus, lai piekristu',
    dma_ggTitle: 'Pielāgotas reklāmas',
    dma_ggContent:
      'Jums ir iespēja atļaut mums izmantot jūsu personīgo informāciju personalizētu reklāmu nolūkos. Ja jūs piekrītat, jūsu personīgā informācija tiks kopīgota ar mūsu partneriem, lai izplatītu reklāmas, kas atbilst jūsu interesēm vai palīdzētu atrast kaut ko jaunu. Otrādi, ja jūs izvēlaties to neļaut, jūsu personīgā informācija netiks izmantota iepriekšminētajam nolūkam. Jūs joprojām varēsiet saņemt reklāmas, bet tās nebūs pielāgotas jūsu personīgajai informācijai un var būt mazāk relevantas. Ja sākotnēji jūs sniedzat piekrišanu mums izmantot jūsu personīgo informāciju personalizētām reklāmām, jums ir tiesības jebkurā laikā atsaukt šo piekrišanu, pielāgojot savas preferences spēles lietotāja centrā.',
    dma_save: 'Saglabāt',
    dma_back: 'Atpakaļ',
    dma_saveSuccess: 'Saglabāts'
  },
  LT: {
    dma_langName: 'lietuvių',
    dma_yhtk: 'Naudotojo Sutartis',
    dma_ysxy: 'Privatumo politika',
    dma_gxhgg: 'Asmeninės Reklamos',
    dma_kx: '(Neprivaloma)',
    dma_gxhgg_subText:
      '*Išjunkite šią parinktį, kad neleistumėte naudoti savo duomenų suasmenintai reklamai.',
    dma_allAgree: 'Sutikti su viskuo',
    dma_agree: 'Sutinku',
    dma_qxgxxy: 'Pasirinkite elementą (-us), su kuriuo (-ais) sutinkate',
    dma_ggTitle: 'Asmeninės Reklamos',
    dma_ggContent:
      'Jūs turite pasirinkimą leisti mums naudoti jūsų asmeninę informaciją sukuriant asmeninės reklamos tikslais. Jei jūs sutinkate, jūsų asmeninė informacija bus bendrinama su mūsų partneriais, siekiant rodyti reklamas, kurios atitinka jūsų interesus arba padėti jums atrasti kažką naujo. Priešingai, jei jūs nuspręsite šito neleisti, jūsų asmeninė informacija nebus naudojama minėtam tikslui. Jūs vis tiek galėsite gauti reklamas, tačiau jos nebus pritaikytos pagal jūsų asmeninę informaciją ir gali būti mažiau aktuali. Jei iš pradžių suteikiate sutikimą mums naudoti jūsų asmeninę informaciją asmeninėms reklamoms, jūs turite teisę bet kuriuo metu atšaukti šį sutikimą, prisitaikydami savo nuostatoms žaidimo vartotojo centre.',
    dma_save: 'Išsaugoti',
    dma_back: 'Atgal',
    dma_saveSuccess: 'Išsaugota'
  },
  HU: {
    dma_langName: 'magyar',
    dma_yhtk: 'Felhasználói Szerződés',
    dma_ysxy: 'Adatvédelmi Irányelv',
    dma_gxhgg: 'Személyre szabott Hirdetések',
    dma_kx: '(Opcionális)',
    dma_gxhgg_subText:
      '*Kapcsolja ki ezt a lehetőséget, ha nem kívánja, hogy adatait személyre szabott hirdetésekhez használják.',
    dma_allAgree: 'Egyetértek minddel',
    dma_agree: 'Egyetértek',
    dma_qxgxxy: 'Válassza ki a tétel(ek)et az egyetértéshez',
    dma_ggTitle: 'Személyre szabott Hirdetések',
    dma_ggContent:
      'Van lehetősége engedélyezni számunkra, hogy személyes információit személyre szabott hirdetések céljából felhasználjuk. Ha beleegyezik, személyes információit megosztjuk partnereinkkel, hogy olyan hirdetéseket szállítsunk, amelyek az Ön érdeklődési köréhez igazodnak, vagy segítsenek Önnek valami újat felfedezni. Ellenkező esetben, ha úgy dönt, hogy ezt nem engedélyezi, személyes információit nem használjuk a fent említett célra. Még mindig kaphat hirdetéseket, azonban azok nem lesznek személyre szabva az Ön személyes információi alapján és kevésbé lehetnek relevánsak. Ha kezdetben beleegyezik, hogy személyes információit személyre szabott hirdetések céljából használjuk, joga van bármikor visszavonni ezt a beleegyezést, a preferenciái beállításával a játék felhasználói központjában.',
    dma_save: 'Mentés',
    dma_back: 'Vissza',
    dma_saveSuccess: 'Mentve'
  },
  MT: {
    dma_langName: 'Malti',
    dma_yhtk: 'L-Akkord tal-Utent',
    dma_ysxy: 'Politika tal-Privatezza',
    dma_gxhgg: 'Reklami Personalizzati',
    dma_kx: '(Opzjonali)',
    dma_gxhgg_subText:
      '*Itfi din l-għażla biex tagħżel li d-dejta tiegħek ma tintużax għal reklami personalizzati.',
    dma_allAgree: 'Agħżel Kollox',
    dma_agree: 'Ikkunsenta',
    dma_qxgxxy: 'Agħżel oġġett(jiet) biex taqbel',
    dma_ggTitle: 'Reklami Personalizzati',
    dma_ggContent:
      "Għandek il-possibbiltà li tippermettilek lillna tuża l-informazzjoni personali tiegħek għal skop ta' reklami personalizzati. Jekk tgħodd, l-informazzjoni personali tiegħek se tkun mniżżla ma' partners tagħna biex jwasslu reklami li huma allinjati mal-interess tiegħek jew biex jgħinuk tgħallim xi ġdid. Min-naħa l-oħra, jekk tgħażel li ma tpermettilekx dan, l-informazzjoni personali tiegħek ma titużax għal skop imsemmi ta' qabel. Għalhekk, għad hemm possibbiltà li tirċievi reklami, iżda ma jkunux personalizzati skond l-informazzjoni personali tiegħek u jistgħu jkunu inqas rilevanti. Jekk inti prinċipalment tiddikjara li tippermettilek lilna nużaw l-informazzjoni personali tiegħek għal reklami personalizzati, għandek id-dritt li tnazzal din il-permess f'kwalunkwe ħin billi tadjusta l-preferenzi tiegħek fil-ġnien tal-utent tal-logħba.",
    dma_save: 'Salva',
    dma_back: 'Wara',
    dma_saveSuccess: 'Saħħaħna'
  },
  RO: {
    dma_langName: 'română',
    dma_yhtk: 'Acordul Utilizatorului',
    dma_ysxy: 'Politica de Confidențialitate',
    dma_gxhgg: 'Anunțuri Personalizate',
    dma_kx: '(Opțional)',
    dma_gxhgg_subText:
      '*Dezactivați această opțiune pentru a alege ca datele dvs. să nu fie utilizate pentru reclame personalizate.',
    dma_allAgree: 'Acord cu toate',
    dma_agree: 'Acord',
    dma_qxgxxy: 'Selectați elementul(e) pentru a fi de acord',
    dma_ggTitle: 'Anunțuri Personalizate',
    dma_ggContent:
      'Aveți opțiunea să ne permiteți să utilizăm informațiile dvs. personale în scopul afișării de reclame personalizate. Dacă dați consimțământul, informațiile dvs. personale vor fi partajate cu partenerii noștri pentru a livra anunțuri care sunt aliniate cu interesele dvs. sau pentru a vă ajuta să descoperiți ceva nou. În mod invers, dacă alegeți să nu permiteți acest lucru, informațiile dvs. personale nu vor fi utilizate în scopul menționat mai sus. Este posibil să primiți în continuare reclame, dar acestea nu vor fi personalizate în funcție de informațiile dvs. personale și pot fi mai puțin relevante. Dacă inițial acordați consimțământul pentru utilizarea informațiilor dvs. personale în scopul reclamelor personalizate, aveți dreptul să revocați acest consimțământ în orice moment ajustând preferințele în centrul de utilizator al jocului.',
    dma_save: 'Salvare',
    dma_back: 'Înapoi',
    dma_saveSuccess: 'Salvat'
  },
  SK: {
    dma_langName: 'slovenčina',
    dma_yhtk: 'Zmluva s Používateľom',
    dma_ysxy: 'Zásady ochrany osobných údajov',
    dma_gxhgg: 'Personalizovaná reklama',
    dma_kx: '(Nepovinné)',
    dma_gxhgg_subText:
      '*Vypnutím tejto možnosti sa rozhodnete neposkytovať svoje údaje na personalizovanú reklamu.',
    dma_allAgree: 'Súhlasiť so všetkým',
    dma_agree: 'Súhlasiť',
    dma_qxgxxy: 'Vybrať položku/položky na súhlas',
    dma_ggTitle: 'Personalizovaná reklama',
    dma_ggContent:
      'Máte možnosť nám dovoliť využívať vaše osobné informácie na účely personalizovaných reklám. Ak súhlasíte, vaše osobné informácie budú zdieľané s našimi partnermi, aby mohli zasielať reklamy zamerané na vaše záujmy alebo vám pomôcť objaviť niečo nové. Naopak, ak sa rozhodnete toto neumožniť, vaše osobné informácie nebudú použité na vyššie uvedený účel. Môžete stále dostávať reklamy, ale nebudú personalizované podľa vašich osobných informácií a môžu byť menej relevantné. Ak súhlasíte s pôvodným použitím vašich osobných informácií na personalizované reklamy, máte právo kedykoľvek tento súhlas odvolať nastavením vašich preferencií v užívateľskom centre hry.',
    dma_save: 'Uložiť',
    dma_back: 'Späť',
    dma_saveSuccess: 'Uložené'
  },
  SL: {
    dma_langName: 'slovenščina',
    dma_yhtk: 'Pogodba uporabnika',
    dma_ysxy: 'Politika zasebnosti',
    dma_gxhgg: 'Personalizirani oglasi',
    dma_kx: '(Opcijsko)',
    dma_gxhgg_subText:
      '*Onemogočite to možnost, da izberete, da se vaši podatki ne uporabljajo za prilagojene oglase.',
    dma_allAgree: 'Soglašam z vsem',
    dma_agree: 'Soglašam',
    dma_qxgxxy: 'Izberi elemente za soglasje',
    dma_ggTitle: 'Personalizirani oglasi',
    dma_ggContent:
      'Imate možnost, da nam dovolite uporabo vaših osebnih podatkov za namene prilagojenega oglaševanja. Če privolite, se bodo vaši osebni podatki delili z našimi partnerji, da bodo lahko posredovali oglase, ki so usklajeni z vašim zanimanjem ali vam pomagali odkriti nekaj novega. Nasprotno, če se odločite, da tega ne želite dovoliti, se vaši osebni podatki ne bodo uporabljali za zgoraj navedene namene. Lahko še vedno prejemate oglase, vendar ne bodo prilagojeni glede na vaše osebne podatke in morda bodo manj relevantni. Če na začetku privolite v uporabo vaših osebnih podatkov za prilagojeno oglaševanje, imate pravico to privolitev kadar koli preklicati z nastavitvijo svojih preferenc v uporabniškem centru igre.',
    dma_save: 'Shrani',
    dma_back: 'Nazaj',
    dma_saveSuccess: 'Shranjeno'
  },
  FI: {
    dma_langName: 'suomi',
    dma_yhtk: 'Käyttäjäsopimus',
    dma_ysxy: 'Tietosuojakäytäntö',
    dma_gxhgg: 'Personoidut mainokset',
    dma_kx: '(Vaihtoehtoinen)',
    dma_gxhgg_subText:
      '*Poista tämä asetus käytöstä, jos et halua, että tietojasi käytetään personoituihin mainoksiin.',
    dma_allAgree: 'Hyväksy kaikki',
    dma_agree: 'Hyväksy',
    dma_qxgxxy: 'Valitse kohteet, joihin suostut',
    dma_ggTitle: 'Personoidut mainokset',
    dma_ggContent:
      'Sinulla on mahdollisuus antaa meille lupa käyttää henkilötietojasi personoitujen mainosten tarkoituksessa. Jos suostut, henkilötietosi jaetaan kumppaneidemme kanssa, jotta voimme toimittaa mainoksia, jotka vastaavat kiinnostustasi tai auttavat sinua löytämään jotain uutta. Toisaalta, jos päätät olla sallimatta tätä, henkilötietojasi ei käytetä edellä mainittuun tarkoitukseen. Voit silti vastaanottaa mainoksia, mutta ne eivät ole personoituja henkilötietojesi perusteella ja saattavat olla vähemmän relevantteja. Mikäli alun perin annat suostumuksen henkilötietojesi käyttöön personoitujen mainosten osalta, sinulla on oikeus peruuttaa tämä suostumus milloin tahansa säätämällä asetuksiasi pelin käyttäjäkeskuksessa.',
    dma_save: 'Tallenna',
    dma_back: 'Takaisin',
    dma_saveSuccess: 'Tallennettu'
  },
  SV: {
    dma_langName: 'svenska',
    dma_yhtk: 'Användaravtal',
    dma_ysxy: 'Integritetspolicy',
    dma_gxhgg: 'Personliga annonser',
    dma_kx: '(Valfritt)',
    dma_gxhgg_subText:
      '*Inaktivera detta alternativ för att välja bort att dina uppgifter används för personanpassade annonser.',
    dma_allAgree: 'Godkänn allt',
    dma_agree: 'Godkänn',
    dma_qxgxxy: 'Välj objekt för att samtycka',
    dma_ggTitle: 'Personliga annonser',
    dma_ggContent:
      'Du har valet att låta oss använda dina personuppgifter för att skräddarsy reklam. Om du samtycker kommer dina personuppgifter att delas med våra partners för att leverera annonser som är anpassade efter dina intressen eller för att hjälpa dig att upptäcka något nytt. Om du däremot väljer att inte tillåta detta kommer dina personuppgifter inte att användas för det nämnda syftet. Du kan fortfarande få reklam, men den kommer inte att vara anpassad efter dina personuppgifter och kan vara mindre relevant. Om du först ger ditt samtycke till att vi använder dina personuppgifter för skräddarsydd reklam har du rätt att återkalla detta samtycke när som helst genom att justera dina preferenser i spelets användarcenter.',
    dma_save: 'Spara',
    dma_back: 'Tillbaka',
    dma_saveSuccess: 'Sparat'
  }
};

export const getLanguage = (lang, key) => {
  return language[lang]?.[key] || language['en-US'][key] || '';
};

export const getDefaultTermList = lang => {
  let info = language[lang] || language['en-US'];
  return [
    {
      name: info.dma_yhtk,
      subName: '',
      require: true,
      link: `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/servicePrivicy/service`,
      title: '',
      content: ''
    },
    {
      name: info.dma_ysxy,
      subName: '',
      require: true,
      link: `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/servicePrivicy/privicy`,
      title: '',
      content: ''
    },
    {
      name: info.dma_gxhgg + info.dma_kx,
      subName: info.dma_gxhgg_subText,
      require: false,
      link: '',
      title: info.dma_ggTitle,
      content: info.dma_ggContent
    }
  ];
};

export const getLanguageList = () => {
  let res = {};
  for (let k in language) {
    res[k] = language[k].dma_langName;
  }
  return res;
};
